import PLANS from '../constants/plans.json';

// GA4 only accepts free/starter/creator/team/enterprise for plan_tier — a
// different naming scheme than PlanCardsGrid's getPlanTier() (which is for
// Mixpanel: intro/standard/advanced). Don't reuse that one here.
const FAMILY_TO_GA4_TIER = {
    free: 'free',
    mini: 'starter', // no dedicated tier for mini-starter-plan-*, closest fit
    starter: 'starter',
    light: 'creator',
    full: 'team',
    enterprise: 'enterprise',
};

const findPlanFamily = (planId) => {
    if (!planId) return null;
    const plan = PLANS.find((p) =>
        p.plan_id_usd === planId || p.plan_id_inr === planId ||
        p.plan_id_usd_annual === planId || p.plan_id_inr_annual === planId
    );
    return plan?.plan_family ?? null;
};

// Derived from plan_id rather than passed around as its own value, so the two
// can't end up disagreeing.
export const getGa4PlanTier = (planId) => {
    if (!planId) return 'free';
    return FAMILY_TO_GA4_TIER[findPlanFamily(planId)] ?? 'free';
};
